
// Update sort_by query parameter on select change
document.querySelector('#sort-by').addEventListener('click', function (e) {
    var value = e.target.value;

    // Check for existing query parameters
    var params = new URLSearchParams(location.search);
    if (params.has('page')) {
        params.delete('page');
    }

    // if (params.has('q')) {
    //   params.delete('q');
    // }

    // Update sort_by parameter
    params.set('sort_by', value);

    // Update URL with new query parameters
    var newUrl = location.protocol + '//' + location.host + location.pathname + '?' + params.toString();
    window.location.href = newUrl;
});

function sorting(value) {

    // Check for existing query parameters
    var params = new URLSearchParams(location.search);
    if (params.has('page')) {
        params.delete('page');
    }

    // if (params.has('q')) {
    //   params.delete('q');
    // }

    // Update sort_by parameter
    params.set('sort_by', value);

    // Update URL with new query parameters
    var newUrl = location.protocol + '//' + location.host + location.pathname + '?' + params.toString();
    window.location.href = newUrl;
}
